<div class="section" style="width: 100%; height: 100%; flex: 1; display: flex; flex-direction: column;" data-cy="case-add-procedure">
  <div class="section-header" data-cy="case-add-procedure-header">
    <div class="section-header-title" data-cy="case-add-procedure-title">{{ isSubProcedureMode ? 'Add Sub-Procedure(s)' : 'Add Procedure(s)' }}</div>
  </div>
  <div class="section-content" style="display: flex; flex-direction: column; flex: 1; min-height: 0; overflow: hidden;" data-cy="case-add-procedure-content">
    @if (isLoading) {
      <app-tdo-progress-spinner style="height: 100%;" data-cy="case-add-procedure-spinner"></app-tdo-progress-spinner>
    }
    @if (!isLoading && isSubProcedureMode) {
      <div style="margin-bottom: 12px;" data-cy="case-add-procedure-parent-container">
        <tdo-dropdown-v2 [datasource]="parentProcedures"
          displayProperty="ProcedureName" placeholder="Select Procedure"
          [value]="selectedParentProcedure"
          (selectionChange)="onParentSelected($event.value)"
          data-cy="case-add-procedure-parent-dropdown">
        </tdo-dropdown-v2>
      </div>
    }
    @if (!isLoading && isSubProcedureMode && isLoadingSubProcedures) {
      <mat-progress-bar mode="indeterminate" data-cy="case-add-procedure-sub-loading"></mat-progress-bar>
    }
    @if (!isLoading && isSubProcedureMode && !hasSelectedParent) {
      <div style="padding: 16px; text-align: center; color: var(--tdo-secondary);" data-cy="case-add-procedure-sub-empty">
        Select a procedure to see its sub-procedures.
      </div>
    }
    @if (!isLoading && isSubProcedureMode && isSubProcedureListEmpty) {
      <div style="padding: 16px; text-align: center; color: var(--tdo-secondary);" data-cy="case-add-procedure-sub-empty">
        No sub-procedures configured for this procedure.
      </div>
    }
    @if (!isLoading) {
      <div style="flex: 1; min-height: 0; overflow-y: auto;" data-cy="case-add-procedure-table-container">
        <tdo-table [dataSource]="cfgCaseProcedures"
          [isMultiSelection]="!isSingleSelection" [isSearchable]="!isSubProcedureMode" [isUsePaginator]="true"
          [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)"
          data-cy="case-add-procedure-table">
          <tdo-table-column displayName="Procedure Name" propertyName="ProcedureName" isSortable="true" [rowTemplate]="procedurename" data-cy="case-add-procedure-column-name">
            <ng-template #procedurename let-row>
              @if (row.ProcedureName) {
                <div data-cy="case-add-procedure-procedure-name">{{ row.ProcedureName }}</div>
              }
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Code" propertyName="Code" isSortable="true" [rowTemplate]="code" data-cy="case-add-procedure-column-code">
            <ng-template #code let-row>
              @if (row.Code) {
                <div data-cy="case-add-procedure-procedure-code">{{ row.Code }}</div>
              }
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </div>
    }

    <div class="action-container" data-cy="case-add-procedure-actions">
      <button class="tdo-button tdo-close" style="margin-right: 12px;" (click)="cancel(false)" data-cy="case-add-procedure-close-btn">Close</button>
      <button [disabled]="selectedCaseProcedure.length === 0" class="tdo-button tdo-save" style="margin-right: 12px;" (click)="saveProcedure()" data-cy="case-add-procedure-save-btn">{{ isSubProcedureMode ? 'Add Sub-Procedure(s)' : 'Add Procedure(s)' }}</button>

    </div>

  </div>
</div>




